import { AppState } from '../root.reducer';

export const getOrganizationBranding = (state: AppState, organizationId: string) =>
  state.organizationBranding.profilesByOrganizationId[organizationId];

export const getHasFetchedOrganizationBranding = (state: AppState, organizationId: string) =>
  !!state.organizationBranding.hasFetchedByOrganizationId[organizationId];

export const getOrganizationBrandingError = (state: AppState, organizationId: string) =>
  state.organizationBranding.errorsByOrganizationId[organizationId];

export const getUploadedOrganizationBrandingLogo = (state: AppState, organizationId: string) =>
  state.organizationBranding.uploadedLogosByOrganizationId[organizationId];

export const getUploadedOrganizationBrandingLogoError = (state: AppState, organizationId: string) =>
  state.organizationBranding.uploadLogoErrorsByOrganizationId[organizationId];

export const getOrganizationBrandingEmailPreview = (state: AppState, organizationId: string) =>
  state.organizationBranding.emailPreviewsByOrganizationId[organizationId];

export const getOrganizationBrandingEmailPreviewError = (state: AppState, organizationId: string) =>
  state.organizationBranding.emailPreviewErrorsByOrganizationId[organizationId];
